import { render, staticRenderFns } from "./RecurringPaymentFrequencyList.vue?vue&type=template&id=91fd6898&scoped=true"
import script from "./RecurringPaymentFrequencyList.vue?vue&type=script&lang=js"
export * from "./RecurringPaymentFrequencyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fd6898",
  null
  
)

export default component.exports